import React from "react"
import { getImageUrl } from "../../../config/s3Config"
import "./Chief.css"

const Chief = () => {
  return (
    <section className='chief-section'>
      <div className='container'>
        <div className='chief-content'>
          <div className='convocation-header'>
            <h1 className='convocation-title'>Annual Convocation 2023</h1>
            <div className='title-underline'></div>
          </div>
          
          <div className='chief-guest-card'>
          
            
            <div className='chief-info'>
              <div className='chief-image'>
                <img 
                  src={getImageUrl("/images/Graduation Special/A014-mi.jpeg")} 
                  alt="Dr. Patric - Chief Guest" 
                  className='chief-photo desktop-photo'
                />
                <img 
                  src={getImageUrl("/images/WEB Post Mobile/web 360x640 Graduation 12.png")} 
                  alt="Dr. Patric - Chief Guest" 
                  className='chief-photo mobile-photo'
                />
              </div>
              
              <div className='chief-details'>
                <h3 className='chief-name'>Dr. Patric</h3>
                <div className='chief-positions'>
                  <p className='position'>Chief Executive Officer & Co-Founder</p>
                  <p className='company'>Medical Consortium</p>
                  <p className='advisor'>Advisor – Middle East, Asia & Europe</p>
                </div>
                
                <div className='quote-section'>
                  <div className='quote-icon'>
                    <i className='fas fa-quote-left'></i>
                  </div>
                  <blockquote className='chief-quote'>
                    "Congratulations graduates! This is the beginning of your journey. Face challenges with courage, keep learning, take risks, inspire others, and carry your values proudly into the world. Your future is bright."
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Chief
